// The boot greeting: "hello" in 30 languages, ending in Bangla. Each entry is the language's everyday greeting as a
// native speaker writes it, with the script it needs (the boot screen loads a font subset for every non-Latin script).

export type Greeting = { word: string; lang: string; dir?: 'rtl'; script: 'latin' | 'bengali' | 'arabic' | 'devanagari' | 'jp' | 'kr' | 'sc' | 'thai' | 'tamil' | 'hebrew' };

export const GREETINGS: Greeting[] = [
  { word: 'Hello', lang: 'en', script: 'latin' },
  { word: 'নমস্কার', lang: 'bn', script: 'bengali' },
  { word: 'Hola', lang: 'es', script: 'latin' },
  { word: 'مرحباً', lang: 'ar', dir: 'rtl', script: 'arabic' },
  { word: 'नमस्ते', lang: 'hi', script: 'devanagari' },
  { word: 'Bonjour', lang: 'fr', script: 'latin' },
  { word: 'こんにちは', lang: 'ja', script: 'jp' },
  { word: '안녕하세요', lang: 'ko', script: 'kr' },
  { word: 'Ciao', lang: 'it', script: 'latin' },
  { word: 'Hallo', lang: 'de', script: 'latin' },
  { word: 'Olá', lang: 'pt', script: 'latin' },
  { word: 'Привет', lang: 'ru', script: 'latin' },
  { word: '你好', lang: 'zh', script: 'sc' },
  { word: 'Merhaba', lang: 'tr', script: 'latin' },
  { word: 'سلام', lang: 'fa', dir: 'rtl', script: 'arabic' },
  { word: 'Hej', lang: 'sv', script: 'latin' },
  { word: 'Γεια σου', lang: 'el', script: 'latin' },
  { word: 'שלום', lang: 'he', dir: 'rtl', script: 'hebrew' },
  { word: 'Xin chào', lang: 'vi', script: 'latin' },
  { word: 'สวัสดี', lang: 'th', script: 'thai' },
  { word: 'Cześć', lang: 'pl', script: 'latin' },
  { word: 'வணக்கம்', lang: 'ta', script: 'tamil' },
  { word: 'آداب', lang: 'ur', dir: 'rtl', script: 'arabic' },
  { word: 'Halo', lang: 'id', script: 'latin' },
  { word: 'Jambo', lang: 'sw', script: 'latin' },
  { word: 'Привіт', lang: 'uk', script: 'latin' },
  { word: 'Kumusta', lang: 'fil', script: 'latin' },
  { word: 'नमस्कार', lang: 'ne', script: 'devanagari' },
  { word: 'Hoi', lang: 'nl', script: 'latin' },
  { word: 'স্বাগতম', lang: 'bn', script: 'bengali' },
];
